import { Switch as MantineSwitch } from '@mantine/core';
import type { SwitchProps as MantineSwitchProps } from '@mantine/core';
import './Switch.css';

export interface SwitchProps extends MantineSwitchProps {}

export default function Switch({
  className = '',
  withThumbIndicator = false,
  size = 'sm',
  ...props
}: SwitchProps) {
  return (
    <MantineSwitch
      className={`app-switch ${className}`.trim()}
      withThumbIndicator={withThumbIndicator}
      size={size}
      {...props}
    />
  );
}
